import { useSelector } from 'react-redux';
import { selectUser, selectIsUserDataRequested } from 'store/auth/authSelectors';
import { useCallback, useMemo } from 'react';
import { isUserHasAdminRoles, isUserHasSomeRoles } from 'utils/userRolesHelper';

const useAuthUser = () => {
    const user = useSelector(selectUser);
    const isUserDataRequested = useSelector(selectIsUserDataRequested);

    const userHasRoles = useCallback((roles) => isUserHasSomeRoles(user, roles), [user]);

    const userHasAdminRoles = useMemo(() => isUserHasAdminRoles(user), [user]);

    return {
        user,
        userHasRoles,
        userHasAdminRoles,
        isUserDataRequested,
    };
};

export default useAuthUser;
